import { render, staticRenderFns } from "./44.vue?vue&type=template&id=380606d0&scoped=true&"
var script = {}
import style0 from "./44.vue?vue&type=style&index=0&id=380606d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380606d0",
  null
  
)

export default component.exports